export const lp: any = {
  searchFlightByDestinationTitle: "{{destination}}への航空券を検索する",
  flightReferencePriceListTitle: "{{destination}}行きの人気の航空券",
  destinationAbout: "{{destination}}について",
  destinationBestSeason: "{{destination}}のベストシーズン",
  conciergeComment: "コンシェルジュコメント",
  destinationMainAirlines: "{{destination}}行きの主な航空会社",
  accessToCity: "都市部へのアクセス方法",
  searchHotelByDestinationTitle: "{{destination}}のホテルを検索する",
  hotelRecommendedListTitle: "{{destination}}でオススメのホテル",
  surroundingRegions: "近くの地域",
  orderExamples: "オーダー例",
  referencePrice: "参考価格",
  cruiseSaleListTitle: "セール中のクルーズ",
  cruiseRegionCruiseListTitle: "{{name}}のクルーズ",
  cruiseRegionFaqTitle: "{{name}}のよくある質問",
  cruiseRegionIntroductionTitle: "{{name}}について",
  vesselCruiseListTitle: "{{name}}のクルーズ",
  vesselCabinListTitle: "{{name}}のキャビン",
  vesselAttractionListTitle: "{{name}}のアトラクション",
  vesselFaqTitle: "{{name}}のよくある質問",
  vesselInfoTitle: "{{name}}の概要",
  vesselIntroductionTitle: "{{name}}について",
  vesselBrandFaqTitle: "{{name}}のよくある質問",
  vesselBrandIntroductionTitle: "{{name}}について",
  vesselBrandVesselListTitle: "{{name}}のクルーズ船",
  searchByVesselRegions: "{{name}}が寄稿する地域から探す",
  searchByDescendingRegions: "{{name}}のエリアから探す",
  searchFromVesselsToRegion: "{{name}}行きの客船から探す",
  regionCruiseListTitle: "エリアから探すクルーズ",
  lpCruiseTitle: "おすすめのクルーズ",
  lpOverseasCruiseTitle: "おすすめの海外クルーズ",
};
